    import { useState } from "react";
    import QRCode from "qrcode";

    import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    Stack
    } from "@mui/material";

    export const WalkInForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        cid: "",
        cod: "",
        dp: ""
    });

    const [qrImage, setQrImage] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
        ...prev,
        [name]: name === "dp" ? Number(value) : value
        }));
    };

    const handleGenerateQR = async (e) => {
        e.preventDefault();

        try {
        const encryptyed = window.btoa(JSON.stringify(formData))
        console.log(encryptyed);
        const qr = await QRCode.toDataURL(encryptyed);
        setQrImage(qr);
        } catch (err) {
        console.error(err);
        }
    };

    return (
        <Box display="flex" justifyContent="center" mt={5}>
        <Paper elevation={3} sx={{ p: 4, width: 400 }}>
            <Typography variant="h5" mb={3}>
            Walk-In Guest Form
            </Typography>

            <form onSubmit={handleGenerateQR}>
            <Stack spacing={2}>
                <TextField
                label="Guest Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
                required
                />

                <TextField
                label="Check-In Date"
                type="date"
                name="cid"
                value={formData.cid}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                required
                />

                <TextField
                label="Check-Out Date"
                type="date"
                name="cod"
                value={formData.cod}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                required
                />

                <TextField
                label="Downpayment"
                type="number"
                name="dp"
                value={formData.dp}
                onChange={handleChange}
                fullWidth
                required
                />

                <Button
                type="submit"
                variant="contained"
                size="large"
                >
                Generate QR
                </Button>
            </Stack>
            </form>

            {qrImage && (
            <Box mt={4} textAlign="center">
                <Typography variant="subtitle1" mb={2}>
                Guest QR Code
                </Typography>
                <img src={qrImage} alt="QR Code" />
            </Box>
            )}
        </Paper>
        </Box>
    );
    };